import { render, staticRenderFns } from "./StudentProfileAchievements.vue?vue&type=template&id=6c1614e8&scoped=true&"
import script from "./StudentProfileAchievements.vue?vue&type=script&lang=js&"
export * from "./StudentProfileAchievements.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileAchievements.vue?vue&type=style&index=0&id=6c1614e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1614e8",
  null
  
)

export default component.exports